<template lang="pug">
main.py-4.px-5.presentation.elevation-4
  v-toolbar.editor__nav.px-3(app, fixed, :clipped-left='true', :clipped-right='true')
    v-btn.hidden-xs-only.transparent(:to='{name: "InventionSolution", params: {id: this.$route.params.id}}', flat, color='secondary', icon)
      v-icon(medium) keyboard_arrow_left
    v-toolbar-title
      | {{ C.data.invention.title }}
      v-layout(row, no-wrap, align-items-center)
        v-flex(v-if='C.data.invention.phase')
          v-layout(row, no-wrap, align-items-center)
            v-icon(small) check_circle
            p.body-2.mb-0.mr-3.ml-1
              | {{ C.dictionary.phase[C.data.invention.phase] }}

        v-flex(v-for='inventor in C.data.invention.co_inventors', :key='inventor.id')
          v-layout(row, no-wrap, align-items-center)
            v-icon(small) people
            p.body-2.mb-0.mr-3.ml-1
              | {{ inventor.user.fullname }}

        v-flex(v-if='C.data.invention.bulk_read_access')
          v-layout(row, no-wrap, align-items-center)
            p.body-2.mb-0.mr-4
              v-icon.mr-1(small) chat_bubble
              | {{ (C.data.invention.bulk_read_access && C.dictionary.bulk_read_access[C.data.invention.bulk_read_access]) ? C.dictionary.bulk_read_access[C.data.invention.bulk_read_access] : C.data.invention.bulk_read_access }}

        v-flex(v-if='C.data.invention.role')
          v-layout(row, no-wrap, align-items-center)
            p.body-2.mb-0.mr-4
              v-icon.mr-1(small) person
              | {{ C.data.invention.role }}

        v-flex(v-if='C.data.invention.opportunity')
          v-layout(row, no-wrap, align-items-center)
            p.body-2.mb-0.mr-4
              v-icon.mr-1(small) add_to_photos
              | {{ C.data.invention.opportunity && C.data.invention.opportunity.title }}

    v-spacer
    v-btn(color='primary', dark, v-if='CR.show.unreleased')
      | Print
      v-icon(right dark) print
    v-btn(@click='C.trigger.exportDocument()', color='primary', dark)
      | Export
      v-icon(right dark) cloud_download
    v-btn(:to='{name: "InventionSolution", params: {id: this.$route.params.id}}', color='secondary', dark)
      | Edit
      v-icon(right dark) mode_edit

  div#js-invention-document(style='font-family: ‘Source Sans Pro’, Helvetica, Arial, sans-serif;')
    v-layout.pb-4(row nowrap align-center justify-space-between)
      v-flex
        .subheading.mb-3 Solution Report – Detailed Disclosure
        .headline
          | {{ C.data.invention.title }}
        .subheading
          | {{ C.data.invention.opportunity && C.data.invention.opportunity.title }}

      img(src="../../assets/img/template-logo-prolific.png")
    v-divider

    ol.presentation--list.mt-4(type="I")
      li
        h1.d-inline-block.mb-3.pl-1(style="font-size: 21px;font-weight: 600;")
          | Specific Problem Being Addressed
        section
          .d-inline
            span(v-html='C.form.selected.invention.container_section.problem_summary.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.gap.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.problem_significance.content', v-if='!C.state.isEditable')
            no-content(v-if='!(C.form.selected.invention.container_section.problem_summary.content || C.form.selected.invention.container_section.gap.content || C.form.selected.invention.container_section.problem_significance.content)')

      li
        h1.d-inline-block.mb-3.pl-1(style="font-size: 21px;font-weight: 600;")
          | Summary of the Solution (Maximum of 150 words)
        section
          .d-inline
            span(v-html='C.form.selected.invention.container_section.summary.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.significance.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.draw.content', v-if='!C.state.isEditable')
            no-content(v-if='!(C.form.selected.invention.container_section.summary.content || C.form.selected.invention.container_section.significance.content || C.form.selected.invention.container_section.draw.content)')

      li
        h1.d-inline-block.mb-3.pl-1(style="font-size: 21px;font-weight: 600;")
          | Technical Landscape and Comparative Advantages of your Solution
        section.pl-4
          .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
            | Landscape
          div(v-html='C.form.selected.invention.container_section.landscape.content', v-if='!C.state.isEditable')
          no-content(v-if='!(C.form.selected.invention.container_section.landscape.content)')

          .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
            | Innovative Aspects
          div(v-html='C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content', v-if='!C.state.isEditable')
          no-content(v-if='!(C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content)')

          div(v-if='C.form.selected.invention.container_section.c_comparativeadvantages && C.form.selected.invention.container_section.c_comparativeadvantages.components')
            .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
              | Current Technologies
            section.pl-4(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_comparativeadvantages.components', :key='componentIndex', :id='`comparativeadvantages-${componentIndex}`')
              .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
                | {{ component.type }}
              .d-inline
                span(v-html='component.items.competing_howworks.content', v-if='!C.state.isEditable')
                span(v-html='component.items.shortcomings.content', v-if='!C.state.isEditable')
                span(v-html='component.items.howovercomes_shortcomings.content', v-if='!C.state.isEditable')
                no-content(v-if='!(component.items.competing_howworks.content || component.items.shortcomings.content || component.items.howovercomes_shortcomings.content)')

          .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
            | Comparative Advantages Summary
          div(v-html='C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content', v-if='!C.state.isEditable')
          no-content(v-if='!(C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content)')


          .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
            | Relevant Background
          div(v-html='C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content', v-if='!C.state.isEditable')
          no-content(v-if='!(C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content)')

      li
        h1.d-inline-block.mb-3.pl-1(style="font-size: 21px;font-weight: 600;")
          | Details of the Invention

        div(v-if='C.form.selected.invention.container_section.c_construction && C.form.selected.invention.container_section.c_construction.components')
          section.pl-4(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_construction.components', :key='componentIndex', :id='`construction-${componentIndex}`')
            .subheading.mb-0(style="font-size: 16px;font-weight: 600;").text--capitalize
              | {{ component.type }}
            div(v-html='component.items.ideal_example.content', v-if='!C.state.isEditable')
            div(v-html='component.items.properties.content', v-if='!C.state.isEditable')
            div(v-html='component.items.how_made.content', v-if='!C.state.isEditable')
            no-content(v-if='!(component.items.ideal_example.content || component.items.properties.content || component.items.how_made.content)')


        section
          .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
            | How is it used?
          div(v-html='C.form.selected.invention.container_section.construction_howused.content', v-if='!C.state.isEditable')
          no-content(v-if='!(C.form.selected.invention.container_section.construction_howused.content)')

          .subheading.mb-0(style="font-size: 16px;font-weight: 600;" v-if='C.form.selected.invention.container_section.construction_prototype.content')
            | Prototype
          div(v-html='C.form.selected.invention.container_section.construction_prototype.content', v-if='!C.state.isEditable')

          .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
            | Economics
          .d-inline
            span(v-html='C.form.selected.invention.container_section.economics_need.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.economics_enduser.content', v-if='!C.state.isEditable')
          .d-inline
            .mb-3
            span(v-html='C.form.selected.invention.container_section.economics_keyresources.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.economics_capitalexpenditure.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.economics_feasiblyeconomical.content', v-if='!C.state.isEditable')
          .d-inline
            .mb-3
            span(v-html='C.form.selected.invention.container_section.economics_whomake.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.economics_howmakemoney.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.economics_howdelivered.content', v-if='!C.state.isEditable')
          .d-inline
            .mb-3
            span(v-html='C.form.selected.invention.container_section.economics_economicburden.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.economics_currentsolutioncosts.content', v-if='!C.state.isEditable')
            span(v-html='C.form.selected.invention.container_section.economics_consumercosts.content', v-if='!C.state.isEditable')
            no-content(v-if='!(C.form.selected.invention.container_section.economics_need.content || C.form.selected.invention.container_section.economics_enduser.content || C.form.selected.invention.container_section.economics_keyresources.content || C.form.selected.invention.container_section.economics_capitalexpenditure.content || C.form.selected.invention.container_section.economics_feasiblyeconomical.content || C.form.selected.invention.container_section.economics_whomake.content || C.form.selected.invention.container_section.economics_howmakemoney.content || C.form.selected.invention.container_section.economics_howdelivered.content || C.form.selected.invention.container_section.economics_economicburden.content || C.form.selected.invention.container_section.economics_currentsolutioncosts.content || C.form.selected.invention.container_section.economics_consumercosts.content)')

      li
        h1.d-inline-block.mb-3.pl-1(style="font-size: 21px;font-weight: 600;")
          | Considerations for Commercialization
        section.pl-4
          ol
            li
              p
                em
                  | What technical gaps must be filled in order to turn your solution into a product?  For each, please estimate when a practical solution will become available.
            li
              p
                em
                  | Many RFIs have specific considerations for commercialization, found in a dedicated section within the RFI (next to “Invention Suggestions.”)  Refer to the RFI for detailed instructions and any RFI-specific questions.  If there are none, proceed to item 3.(For reference, example considerations may include: estimate the bulk cost of critical components or materials; estimate the time horizon when technology gaps will be filled.)
              div(v-html='C.form.selected.invention.container_section.specificquestions.content', v-if='!C.state.isEditable')
              no-content(v-if='!(C.form.selected.invention.container_section.specificquestions.content)')
            li
              p
                em
                  | What key milestones would you recommend for a project to demonstrate proof of concept for your solution?

            div(v-if='C.form.selected.invention.container_section.c_development && C.form.selected.invention.container_section.c_development.components')
              .mb-4(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_development.components', :key='componentIndex', :id='`development-${componentIndex}`')
                .subheading.mb-0(style="font-size: 16px;font-weight: 600;")
                  | Milestone {{ (componentIndex + 1) }}: {{ component.type }}
                ul.milestone--list
                  li
                    strong
                      | Key Points:
                    .d-inline.ml-2(v-html='component.items.key_points.content', v-if='!C.state.isEditable')
                    no-content(v-if='!(component.items.key_points.content)')
                  li
                    strong
                      | Resources Needed:
                    .d-inline.ml-2(v-html='component.items.resources_needed.content', v-if='!C.state.isEditable')
                    no-content(v-if='!(component.items.resources_needed.content)')
                  li
                    strong
                      | Deliverables:
                    .d-inline.ml-2(v-html='component.items.deliverables.content', v-if='!C.state.isEditable')
                    no-content(v-if='!(component.items.deliverables.content)')
                  li
                    strong
                      | Measure of Success:
                    .d-inline.ml-2(v-html='component.items.measure_of_success.content', v-if='!C.state.isEditable')
                    no-content(v-if='!(component.items.measure_of_success.content)')
                  li
                    strong
                      | Key Risks:
                    .d-inline.ml-2(v-html='component.items.key_risks.content', v-if='!C.state.isEditable')
                    no-content(v-if='!(component.items.key_risks.content)')
                  li
                    strong
                      | Suggested Approach:
                    .d-inline.ml-2(v-html='component.items.suggested_approach.content', v-if='!C.state.isEditable')
                    no-content(v-if='!(component.items.suggested_approach.content)')
            li
              p: em
                | Are you interested in participating in a project to demonstrate proof of concept if the idea is selected? __yes  ___no.  If yes, please briefly describe your related expertise and any access facilities that could support the project.

      li
        h1.d-inline-block.mb-3.pl-1(style="font-size: 21px;font-weight: 600;")
          | References
        div(v-html='C.form.selected.invention.container_section.references.content', v-if='!C.state.isEditable')
        no-content(v-if='!(C.form.selected.invention.container_section.references.content)')

</template>

<script>
  import Vue from 'vue'

  import CompletionCheck from './CompletionCheck'
  import NoContent from './NoContent'

  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'

  import axios from '../../../node_modules/axios/dist/axios.js'
  import $ from 'jquery'
  import _ from '../../../node_modules/underscore/underscore-min.js'
  import Avatar from 'vue-avatar'

  import htmlDocx from '../../../node_modules/html-docx-js/dist/html-docx.js'
  import saveAs from '../../../node_modules/html-docx-js/test/vendor/FileSaver.js'

  export default {
    components: {
      Avatar,
      'completion-check': CompletionCheck,
      'no-content': NoContent
    },
    data () {
      return {
        settingsPanel: null,
        tab: 'tab-commments',
        active: null,
        toggleSectionCompleted: null,
        CR: {
          authorization: globalSettings.authorization,
          show: globalSettings.show
        },
        C: {
          config: {
            containerSections: []
          },
          timer: {
            autoSave: null,
            saveIndicator: null
          },
          state: {
            initialized: false,
            isEditable: false,
            autoSave: {
              containers: false,
              scratchpad: false
            },
            tab: {
              construction: {
                active: null,
                item: null
              },
              comparativeadvantages: {
                active: null,
                item: null
              },
              development: {
                active: null,
                item: null
              }
            },
            dialog: {
              confirmComparativeadvantagesComponentDelete: {
                active: false
              },
              confirmConstructionComponentDelete: {
                active: false
              },
              confirmDevelopmentComponentDelete: {
                active: false
              }
            },
            container: [
              {
                title: 'Solution',
                phaseThreshold: 2,
                active: true,
                items: [
                  {
                    key: 'summary',
                    title: 'Summary',
                    href: '#solution-summary',
                    includeAPI: true
                  },
                  {
                    key: 'draw',
                    title: 'Draw',
                    href: '#solution-draw',
                    includeAPI: true
                  },
                  {
                    key: 'significance',
                    title: 'Significance',
                    href: '#solution-significance',
                    includeAPI: true
                  },
                  {
                    key: 'landscape',
                    title: 'Landscape',
                    href: '#solution-landscape',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'Problem',
                phaseThreshold: 2,
                inactive: true,
                items: [
                  {
                    key: 'problem_summary',
                    title: 'Summary',
                    href: '#problem-summary',
                    includeAPI: true
                  },
                  {
                    key: 'gap',
                    title: 'Gap',
                    href: '#problem-gap',
                    includeAPI: true
                  },
                  {
                    key: 'problem_significance',
                    title: 'Significance',
                    href: '#problem-significance',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'Comparative Advantages',
                phaseThreshold: 3,
                inactive: true,
                componentContainerKey: 'comparativeadvantages',
                items: [{
                  title: 'General Info',
                  href: '#comparativeadvantages-general',
                  includeAPI: false,
                  notComponent: true,
                  subAPIitems: [{
                    key: 'comparativeadvantages_innovativeaspects',
                    title: 'Innovative Aspects'
                  }, {
                    key: 'comparativeadvantages_advantagessummary',
                    title: 'Summary'
                  }, {
                    key: 'comparativeadvantages_relevantbackground',
                    title: 'Relevant Background'
                  }]
                }],
                navSelectTrigger: () => {
                  var component = this

                  component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base'
                }
              },
              {
                title: 'Construction',
                phaseThreshold: 3,
                inactive: true,
                componentContainerKey: 'construction',
                items: [{
                  title: 'General Info',
                  href: '#construction-general',
                  includeAPI: false,
                  notComponent: true,
                  subAPIitems: [{
                    key: 'construction_howused',
                    title: 'How is it used?'
                  }, {
                    key: 'construction_prototype',
                    title: 'Prototype (Optional)'
                  }]
                }]
              },
              {
                title: 'Economics',
                phaseThreshold: 3,
                inactive: true,
                items: [
                  {
                    key: 'economics_need',
                    title: 'Market Need',
                    href: '#economics-need',
                    includeAPI: true
                  },
                  {
                    key: 'economics_enduser',
                    title: 'End User',
                    href: '#economics-enduser',
                    includeAPI: true
                  },
                  {
                    key: 'economics_keyresources',
                    title: 'Key Resources',
                    href: '#economics-keyresources',
                    includeAPI: true
                  },
                  {
                    key: 'economics_capitalexpenditure',
                    title: 'Expenditure Requirements',
                    href: '#economics-capitalexpenditure',
                    includeAPI: true
                  },
                  {
                    key: 'economics_feasiblyeconomical',
                    title: 'Economical Feasibility',
                    href: '#economics-feasiblyeconomical',
                    includeAPI: true
                  },
                  {
                    key: 'economics_whomake',
                    title: 'Who',
                    href: '#economics-whomake',
                    includeAPI: true
                  },
                  {
                    key: 'economics_howmakemoney',
                    title: 'Make Money',
                    href: '#economics-howmakemoney',
                    includeAPI: true
                  },
                  {
                    key: 'economics_howdelivered',
                    title: 'Delivery',
                    href: '#economics-howdelivered',
                    includeAPI: true
                  },
                  {
                    key: 'economics_economicburden',
                    title: 'Economic Burden',
                    href: '#economics-economicburden',
                    includeAPI: true
                  },
                  {
                    key: 'economics_currentsolutioncosts',
                    title: 'Current Solution Costs',
                    href: '#economics-currentsolutioncosts',
                    includeAPI: true
                  },
                  {
                    key: 'economics_consumercosts',
                    title: 'Customer Costs',
                    href: '#economics-consumercosts',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'Development',
                phaseThreshold: 3,
                inactive: true,
                componentContainerKey: 'development',
                items: []
              },
              {
                title: 'Specific Questions',
                phaseThreshold: 3,
                inactive: true,
                hideItemsList: true,
                items: [
                  {
                    key: 'specificquestions',
                    title: '',
                    href: '#specificquestions-specificquestions',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'References',
                phaseThreshold: 3,
                inactive: true,
                hideItemsList: true,
                items: [
                  {
                    key: 'references',
                    title: '',
                    href: '#references-references',
                    includeAPI: true
                  }
                ]
              }
            ]
          },
          data: {
            invention: {}
          },
          form: {
            config: {
              froala: {
                invention: {
                  description: tools.setupFroalaConfig(),
                  scratchpad: tools.setupFroalaConfig(),
                  container_section: {
                    draw: {
                      content: tools.setupFroalaConfig({
                        placeholderText: '',
                        pluginsEnabled: ['image'],
                        toolbarButtons: [
                          'insertImage'
                        ]
                      })
                    }
                  }
                }
              }
            },
            state: {
              active: {
                $search: false
              },
              recentSaveActive: false
            },
            list: {
              constructionComponentOptions: [{
                label: 'Material',
                key: 'material'
              }, {
                label: 'Sub-Component',
                key: 'sub-component'
              }, {
                label: 'Component',
                key: 'component'
              }, {
                label: 'Device',
                key: 'device'
              }, {
                label: 'System',
                key: 'system'
              }, {
                label: 'Service',
                key: 'service'
              }],
              collaboratorAccessOptions: {
                items: [{
                  label: 'Co-inventor',
                  value: 1
                }, {
                  label: 'Mentor/Expert',
                  value: 2
                }, {
                  label: 'Commenter',
                  value: 3
                }],
                dictionary: {
                  '1': 'Co-inventor',
                  '2': 'Mentor/Expert',
                  '3': 'Commenter'
                }
              },
              bulkDefaultAccessOptions: [{
                label: 'Anyone in my organization can comment',
                value: 'anyone-organization'
              }, {
                label: 'Only collaborators in my organization can comment',
                value: 'only-inventors'
              }],
              opportunities: []
            },
            selected: {
              invention_id: null,
              invention: {
                title: '',
                description: '',
                search_list: '',
                keywords: '',
                search_results: '',
                action: '',
                action_note: '',
                search: [],
                $search: {
                  title: '',
                  url: '',
                  note: '',
                  tag: ''
                },
                uploaded_filename: '',
                invention_opportunity_id: null,
                organization_id: null,
                bulk_read_access: null,
                container_section: {}
              },
              $collaborator: {
                $item: null,
                access: null
              },
              scratchpad: '',
              co_inventors: [],
              upload: null,
              comments: {
                $list: [],
                content: ''
              }
            },
            trigger: {
              addSearchItem: (searchItem) => {
                var component = this

                component.C.form.selected.invention.search.push({
                  title: component.C.form.selected.invention.$search.title,
                  url: component.C.form.selected.invention.$search.url,
                  note: component.C.form.selected.invention.$search.note,
                  tag: component.C.form.selected.invention.$search.tag
                })

                component.C.form.selected.invention.$search.title = ''
                component.C.form.selected.invention.$search.url = ''
                component.C.form.selected.invention.$search.note = ''
                component.C.form.selected.invention.$search.tag = ''

                component.C.form.state.active.$search = false
              },
              removeSearchItem: (searchItem, searchItemIndex) => {
                var component = this

                if (!searchItem.id) {
                  component.C.form.selected.invention.search.splice(searchItemIndex, 1)
                } else {
                  Vue.set(searchItem, 'remove', !searchItem.remove)
                }
              },
              addCollaboratorItem: () => {
                var component = this

                if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                  component.C.form.selected.co_inventors.push({
                    $isNew: true,
                    $name: component.C.form.selected.$collaborator.$item.fullname,
                    user_id: component.C.form.selected.$collaborator.$item.id,
                    access: component.C.form.selected.$collaborator.access,
                    remove: false
                  })

                  component.C.form.selected.$collaborator.$item = null
                  component.C.form.selected.$collaborator.access = null
                }
              },
              removeCollaboratorItem: (collaboratorItem, collaboratorIndex) => {
                var component = this

                if (collaboratorItem.$isNew) {
                  component.C.form.selected.co_inventors.splice(collaboratorIndex, 1)
                } else {
                  Vue.set(collaboratorItem, 'remove', !collaboratorItem.remove)
                }
              },
              selectContainerItem: (targetContainer) => {
                if (targetContainer.navSelectTrigger) {
                  targetContainer.navSelectTrigger()
                }
              },
              selectContainerSectionItem: (targetData) => {
                targetData = targetData || {}
                var item = targetData.item || {}
                var subItem = targetData.subItem || {}
                var targetIndex = targetData.index

                var component = this

                if (item.componentContainerKey) {
                  if (subItem.useByIndex) {
                    component.C.state.tab[item.componentContainerKey].active = `${item.componentContainerKey}-${targetIndex}`
                  } else {
                    component.C.state.tab[item.componentContainerKey].active = `${subItem.href}`.substr(1)
                  }
                }
              },
              updateAllContainerSections: (callback, negateDeletion) => {
                var component = this
                callback = callback || _.noop

                var submitItem = {
                  invention_id: parseInt(component.$route.params.id)
                }

                for (var i = 0; i < component.C.config.containerSections.length; i++) {
                  submitItem[component.C.config.containerSections[i]] = component.C.form.selected.invention.container_section[component.C.config.containerSections[i]].content
                }

                submitItem.c_comparativeadvantages = []
                submitItem.c_constructions = []
                submitItem.c_developments = []

                for (i = 0; i < component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length; i++) {
                  var currentComponent = component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i]

                  submitItem.c_comparativeadvantages.push({
                    id: currentComponent.id,
                    c_type: currentComponent.type,
                    delete: (currentComponent.delete || false) && !negateDeletion,
                    competing_howworks: currentComponent.items.competing_howworks.content,
                    shortcomings: currentComponent.items.shortcomings.content,
                    howovercomes_shortcomings: currentComponent.items.howovercomes_shortcomings.content
                  })
                }

                for (i = 0; i < component.C.form.selected.invention.container_section.c_construction.components.length; i++) {
                  currentComponent = component.C.form.selected.invention.container_section.c_construction.components[i]

                  submitItem.c_constructions.push({
                    id: currentComponent.id,
                    c_type: currentComponent.type,
                    delete: (currentComponent.delete || false) && !negateDeletion,
                    ideal_example: currentComponent.items.ideal_example.content,
                    properties: currentComponent.items.properties.content,
                    how_made: currentComponent.items.how_made.content,
                    innovative_aspects: currentComponent.items.innovative_aspects.content,
                    why_hasnt_done_before: currentComponent.items.why_hasnt_done_before.content
                  })
                }

                for (i = 0; i < component.C.form.selected.invention.container_section.c_development.components.length; i++) {
                  currentComponent = component.C.form.selected.invention.container_section.c_development.components[i]

                  submitItem.c_developments.push({
                    id: currentComponent.id,
                    c_type: currentComponent.type,
                    delete: (currentComponent.delete || false) && !negateDeletion,
                    key_points: currentComponent.items.key_points.content,
                    resources_needed: currentComponent.items.resources_needed.content,
                    deliverables: currentComponent.items.deliverables.content,
                    measure_of_success: currentComponent.items.measure_of_success.content,
                    key_risks: currentComponent.items.key_risks.content,
                    suggested_approach: currentComponent.items.suggested_approach.content
                  })
                }

                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/container_sections/update`, submitItem)
                  .then(function (response) {
                    console.info('Update Container Sections Results: ', response.data)

                    callback(response.data)
                  })
                  .catch(function (errorResponse) {
                    tools.alert({
                      type: 'error',
                      errorResponse: errorResponse
                    })
                  })
              },
              addComparativeadvantagesComponent: () => {
                var component = this

                var targetComponentType = `Current Technology ${component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length + 1}`

                component.C.form.selected.invention.container_section.c_comparativeadvantages.components.push({
                  type: targetComponentType,
                  items: {
                    competing_howworks: {
                      content: ''
                    },
                    shortcomings: {
                      content: ''
                    },
                    howovercomes_shortcomings: {
                      content: ''
                    }
                  }
                })

                var comparativeadvantagesComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length - 1

                component.C.state.container[2].items.splice(component.C.state.container[2].items.length - 1, 0, {
                  key: targetComponentType,
                  title: targetComponentType, // ### TEMPORARY - Need label
                  href: `#comparativeadvantages-${comparativeadvantagesComponentIndex}`,
                  useByIndex: true
                })

                component.C.state.tab.comparativeadvantages.active = `comparativeadvantages-${comparativeadvantagesComponentIndex}`

                component.C.trigger.scrollToTop()
              },
              addConstructionComponent: (targetComponentType) => {
                var component = this

                component.C.form.selected.invention.container_section.c_construction.components.push({
                  type: targetComponentType,
                  items: {
                    ideal_example: {
                      content: ''
                    },
                    properties: {
                      content: ''
                    },
                    how_made: {
                      content: ''
                    },
                    innovative_aspects: {
                      content: ''
                    },
                    why_hasnt_done_before: {
                      content: ''
                    }
                  }
                })

                var constructionComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.length - 1

                component.C.state.container[3].items.splice(component.C.state.container[3].items.length - 1, 0, {
                  key: targetComponentType,
                  title: targetComponentType, // ### TEMPORARY - Need label
                  href: `#construction-${constructionComponentIndex}`,
                  useByIndex: true
                })

                component.C.state.tab.construction.active = `construction-${constructionComponentIndex}`

                component.C.trigger.scrollToTop()
              },
              addDevelopmentComponent: () => {
                var component = this

                var targetComponentType = `Milestone ${component.C.form.selected.invention.container_section.c_development.components.length + 1}`

                component.C.form.selected.invention.container_section.c_development.components.push({
                  type: targetComponentType,
                  items: {
                    key_points: {
                      content: ''
                    },
                    resources_needed: {
                      content: ''
                    },
                    deliverables: {
                      content: ''
                    },
                    measure_of_success: {
                      content: ''
                    },
                    key_risks: {
                      content: ''
                    },
                    suggested_approach: {
                      content: ''
                    }
                  }
                })

                var developmentComponentIndex = component.C.form.selected.invention.container_section.c_development.components.length - 1

                component.C.state.container[5].items.push({
                  key: targetComponentType,
                  title: targetComponentType, // ### TEMPORARY - Need label
                  href: `#development-${developmentComponentIndex}`,
                  useByIndex: true
                })

                component.C.state.tab.development.active = `development-${developmentComponentIndex}`

                component.C.trigger.scrollToTop()
              },
              deleteComparativeadvantagesComponent: (targetComponent, confirmedDeletion) => {
                var component = this

                var targetComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.indexOf(targetComponent)

                if (!_.isUndefined(targetComponent.id)) {
                  if (targetComponent.delete) {
                    Vue.set(targetComponent, 'delete', false)
                  } else {
                    Vue.set(targetComponent, 'delete', true)
                  }
                } else {
                  if (!confirmedDeletion && (targetComponent.items.competing_howworks.content || targetComponent.items.shortcomings.content || targetComponent.items.howovercomes_shortcomings.content)) {
                    component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = true
                    component.C.trigger.confirmComparativeadvantagesComponentDelete = function () {
                      component.C.form.trigger.deleteComparativeadvantagesComponent(targetComponent, true)
                    }
                  } else {
                    if (component.C.state.tab.comparativeadvantages.active === `comparativeadvantages-${targetComponentIndex}`) {
                      component.C.state.tab.comparativeadvantages.active = `comparativeadvantages-${targetComponentIndex - 1}`
                    }

                    component.C.state.container[2].items.splice(targetComponentIndex, 1)
                    component.C.form.selected.invention.container_section.c_comparativeadvantages.components.splice(targetComponentIndex, 1)

                    component.C.trigger.confirmComparativeadvantagesComponentDelete = _.noop
                    component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false
                  }
                }
              },
              deleteConstructionComponent: (targetComponent, confirmedDeletion) => {
                var component = this

                var targetComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.indexOf(targetComponent)

                if (!_.isUndefined(targetComponent.id)) {
                  if (targetComponent.delete) {
                    Vue.set(targetComponent, 'delete', false)
                  } else {
                    Vue.set(targetComponent, 'delete', true)
                  }
                } else {
                  if (!confirmedDeletion && (targetComponent.items.how_made.content || targetComponent.items.ideal_example.content || targetComponent.items.innovative_aspects.content || targetComponent.items.properties.content || targetComponent.items.why_hasnt_done_before.content)) {
                    component.C.state.dialog.confirmConstructionComponentDelete.active = true
                    component.C.trigger.confirmConstructionComponentDelete = function () {
                      component.C.form.trigger.deleteConstructionComponent(targetComponent, true)
                    }
                  } else {
                    if (component.C.state.tab.construction.active === `construction-${targetComponentIndex}`) {
                      component.C.state.tab.construction.active = `construction-${targetComponentIndex - 1}`
                    }

                    component.C.state.container[3].items.splice(targetComponentIndex, 1)
                    component.C.form.selected.invention.container_section.c_construction.components.splice(targetComponentIndex, 1)

                    component.C.trigger.confirmConstructionComponentDelete = _.noop
                    component.C.state.dialog.confirmConstructionComponentDelete.active = false
                  }
                }
              },
              deleteDevelopmentComponent: (targetComponent, confirmedDeletion) => {
                var component = this

                var targetComponentIndex = component.C.form.selected.invention.container_section.c_development.components.indexOf(targetComponent)

                if (!_.isUndefined(targetComponent.id)) {
                  if (targetComponent.delete) {
                    Vue.set(targetComponent, 'delete', false)
                  } else {
                    Vue.set(targetComponent, 'delete', true)
                  }
                } else {
                  if (!confirmedDeletion && (targetComponent.items.key_points.content || targetComponent.items.resources_needed.content || targetComponent.items.deliverables.content || targetComponent.items.measure_of_success.content || targetComponent.items.key_risks.content || targetComponent.items.suggested_approach.content)) {
                    component.C.state.dialog.confirmDevelopmentComponentDelete.active = true
                    component.C.trigger.confirmDevelopmentComponentDelete = function () {
                      component.C.form.trigger.deleteDevelopmentComponent(targetComponent, true)
                    }
                  } else {
                    if (component.C.state.tab.development.active === `development-${targetComponentIndex}`) {
                      component.C.state.tab.development.active = `development-${targetComponentIndex - 1}`
                    }

                    component.C.state.container[5].items.splice(targetComponentIndex, 1)
                    component.C.form.selected.invention.container_section.c_development.components.splice(targetComponentIndex, 1)

                    component.C.trigger.confirmDevelopmentComponentDelete = _.noop
                    component.C.state.dialog.confirmDevelopmentComponentDelete.active = false
                  }
                }
              },
              saveSidePanelItems: (callback, skipClose) => {
                var component = this
                callback = callback || _.noop

                var submitBlob = new FormData()
                submitBlob.append('invention[title]', component.C.form.selected.invention.title)
                submitBlob.append('scratchpad', component.C.form.selected.scratchpad)
                submitBlob.append('invention[search_list]', component.C.form.selected.invention.search_list)
                submitBlob.append('invention[keywords]', component.C.form.selected.invention.keywords)
                submitBlob.append('invention[search_results]', component.C.form.selected.invention.search_results)

                submitBlob.append('invention[organization_id]', component.C.form.selected.invention.organization_id)

                submitBlob.append('invention_id', component.C.form.selected.invention_id)

                if (!skipClose) {
                  if (component.C.form.selected.invention.invention_opportunity_id === '$other') {
                    submitBlob.append('invention[invention_opportunity_id]', 'other')
                  } else if (component.C.form.selected.invention.invention_opportunity_id) {
                    submitBlob.append('invention[invention_opportunity_id]', component.C.form.selected.invention.invention_opportunity_id)
                  }

                  for (var i = 0; i < component.C.form.selected.co_inventors.length; i++) {
                    submitBlob.append('co_inventors[][user_id]', component.C.form.selected.co_inventors[i].user_id)
                    submitBlob.append('co_inventors[][access]', component.C.form.selected.co_inventors[i].access)
                    submitBlob.append('co_inventors[][remove]', component.C.form.selected.co_inventors[i].remove || false)
                  }

                  if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                    submitBlob.append('co_inventors[][user_id]', component.C.form.selected.$collaborator.$item.id)
                    submitBlob.append('co_inventors[][access]', component.C.form.selected.$collaborator.access)
                    submitBlob.append('co_inventors[][remove]', false)
                  }

                  for (i = 0; i < component.C.form.selected.invention.search.length; i++) {
                    var targetSearchItem = component.C.form.selected.invention.search[i]

                    submitBlob.append('searches[][id]', (targetSearchItem.id || null))
                    submitBlob.append('searches[][title]', targetSearchItem.title)
                    submitBlob.append('searches[][url]', targetSearchItem.url)
                    submitBlob.append('searches[][note]', targetSearchItem.note)
                    submitBlob.append('searches[][tag]', targetSearchItem.tag)
                    submitBlob.append('searches[][remove]', (targetSearchItem.remove || false))
                  }

                  if (component.C.form.selected.invention.$search.title) {
                    submitBlob.append('searches[][id]', null)
                    submitBlob.append('searches[][title]', component.C.form.selected.invention.$search.title)
                    submitBlob.append('searches[][url]', component.C.form.selected.invention.$search.url)
                    submitBlob.append('searches[][note]', component.C.form.selected.invention.$search.note)
                    submitBlob.append('searches[][tag]', component.C.form.selected.invention.$search.tag)
                    submitBlob.append('searches[][remove]', false)
                  }

                  if (component.C.form.selected.invention.bulk_read_access) {
                    submitBlob.append('invention[bulk_read_access]', component.C.form.selected.invention.bulk_read_access)
                  }
                } else {
                  var targetOpportunityID = (component.C.data.invention.opportunity && component.C.data.invention.opportunity.id)

                  if (targetOpportunityID === -1) {
                    submitBlob.append('invention[invention_opportunity_id]', 'other')
                  } else {
                    submitBlob.append('invention[invention_opportunity_id]', targetOpportunityID)
                  }

                  if (component.C.data.invention.bulk_read_access) {
                    submitBlob.append('invention[bulk_read_access]', component.C.data.invention.bulk_read_access)
                  }
                }

                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update`, submitBlob)
                    .then(function (response) {
                      console.info('Manage Invention Results: ', response.data)

                      callback(response.data)
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
              },
              addComment: () => {
                var component = this

                var apiCallPromise = null

                var submitBlob = new FormData()
                submitBlob.append('invention_id', component.C.form.selected.invention_id)
                submitBlob.append('content', component.C.form.selected.comments.content)

                apiCallPromise = axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/add_comment`, submitBlob)

                if (apiCallPromise) {
                  apiCallPromise
                    .then(function (response) {
                      console.info('Add Comment Results: ', response.data)

                      component.C.form.selected.comments.$list = (response.data && response.data.data && response.data.data.invention && response.data.data.invention.comments) || []

                      component.C.form.selected.comments.content = ''
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
                }
              },
              markInventionComplete: () => {
                var component = this

                if (component.C.data.invention.phase === 'phase-4' && component.C.data.invention.role === 'Mentor') {
                  axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update_phase`, {
                    invention_id: component.$route.params.id,
                    phase: 'phase-5'
                  })
                    .then(function (response) {
                      console.info('Update Phase Results: ', response.data)

                      component.C.trigger.setupInvention()

                      tools.alert({
                        type: 'success',
                        message: `The status for ${component.C.form.selected.invention.title} has been set to Invention Complete.`
                      })
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        message: `Changes to ${component.C.form.selected.invention.title} have been saved, but status failed to be updated to Invention Review.`,
                        errorResponse: errorResponse
                      })
                    })
                }
              },
              saveAll: (isPresentation) => {
                var component = this

                clearTimeout(component.C.timer.autoSave)

                component.C.form.trigger.saveSidePanelItems(function (sidePanelResponse) {
                  component.C.form.trigger.updateAllContainerSections(function (containerSectionResponse) {
                    component.C.form.state.recentSaveActive = true

                    function saveAllComplete (messageAddendum) {
                      component.C.trigger.setupInvention()

                      tools.alert({
                        type: 'success',
                        message: `Changes to ${component.C.form.selected.invention.title} have been saved${messageAddendum ? ' and ' + messageAddendum : ''}.`
                      })
                    }

                    function checkContainerBulkCompletion (targetContainer) {
                      targetContainer.components = targetContainer.components || []

                      if (targetContainer.components.length > 0) {
                        targetContainer.completion = true

                        for (var i = 0; i < targetContainer.components.length; i++) {
                          targetContainer.completion = targetContainer.completion && targetContainer.components[i].completion
                        }
                      }
                    }

                    if (isPresentation) {
                      component.$router.push({
                        name: 'InventionPresentation',
                        params: {
                          id: component.$route.params.id
                        }
                      })
                    } else {
                      var inventionItem = (containerSectionResponse && containerSectionResponse.data && containerSectionResponse.data.invention) || {}

                      var csResult = inventionItem.container_section || {}
                      csResult.summary = csResult.summary || {}
                      csResult.draw = csResult.draw || {}
                      csResult.significance = csResult.significance || {}
                      csResult.landscape = csResult.landscape || {}
                      csResult.problem_summary = csResult.problem_summary || {}
                      csResult.gap = csResult.gap || {}
                      csResult.problem_significance = csResult.problem_significance || {}

                      csResult.comparativeadvantages_innovativeaspects = csResult.comparativeadvantages_innovativeaspects || {}
                      csResult.comparativeadvantages_advantagessummary = csResult.comparativeadvantages_advantagessummary || {}
                      csResult.comparativeadvantages_relevantbackground = csResult.comparativeadvantages_relevantbackground || {}
                      csResult.construction_howused = csResult.construction_howused || {}
                      csResult.construction_prototype = csResult.construction_prototype || {}
                      csResult.economics_need = csResult.economics_need || {}
                      csResult.economics_enduser = csResult.economics_enduser || {}
                      csResult.economics_keyresources = csResult.economics_keyresources || {}
                      csResult.economics_capitalexpenditure = csResult.economics_capitalexpenditure || {}
                      csResult.economics_feasiblyeconomical = csResult.economics_feasiblyeconomical || {}
                      csResult.economics_whomake = csResult.economics_whomake || {}
                      csResult.economics_howmakemoney = csResult.economics_howmakemoney || {}
                      csResult.economics_howdelivered = csResult.economics_howdelivered || {}
                      csResult.economics_economicburden = csResult.economics_economicburden || {}
                      csResult.economics_currentsolutioncosts = csResult.economics_currentsolutioncosts || {}
                      csResult.economics_consumercosts = csResult.economics_consumercosts || {}
                      csResult.specificquestions = csResult.specificquestions || {}
                      csResult.references = csResult.references || {}

                      csResult.c_comparativeadvantages = csResult.c_comparativeadvantages || {}
                      checkContainerBulkCompletion(csResult.c_comparativeadvantages)
                      csResult.c_construction = csResult.c_construction || {}
                      checkContainerBulkCompletion(csResult.c_construction)
                      csResult.c_development = csResult.c_development || {}
                      checkContainerBulkCompletion(csResult.c_development)

                      var hasMentor = !!_.find(inventionItem.collaborators, function (collaborator) {
                        return (collaborator && collaborator.role && collaborator.role.code === 'mentor')
                      })

                      if (
                        inventionItem.phase === 'phase-2' && ((inventionItem.searches.length >= 1) && csResult.summary.completion && csResult.draw.completion && csResult.significance.completion && csResult.landscape.completion && csResult.problem_summary.completion && csResult.gap.completion && csResult.problem_significance.completion)
                      ) {
                        axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update_phase`, {
                          invention_id: component.$route.params.id,
                          phase: 'phase-3'
                        })
                          .then(function (response) {
                            console.info('Update Phase Results: ', response.data)

                            saveAllComplete('invention status has been updated to Invention Full')
                          })
                          .catch(function (errorResponse) {
                            tools.alert({
                              type: 'error',
                              message: `Changes to ${component.C.form.selected.invention.title} have been saved, but status failed to be updated to Invention Full.`,
                              errorResponse: errorResponse
                            })
                          })
                      } else if (
                        inventionItem.phase === 'phase-3' && ((inventionItem.searches.length >= 2) && csResult.summary.completion && csResult.draw.completion && csResult.significance.completion && csResult.landscape.completion && csResult.problem_summary.completion && csResult.gap.completion && csResult.problem_significance.completion) && (hasMentor && csResult.comparativeadvantages_innovativeaspects.completion && csResult.comparativeadvantages_advantagessummary.completion && csResult.comparativeadvantages_relevantbackground.completion && csResult.construction_howused.completion && csResult.construction_prototype.completion && csResult.economics_need.completion && csResult.economics_enduser.completion && csResult.economics_keyresources.completion && csResult.economics_capitalexpenditure.completion && csResult.economics_feasiblyeconomical.completion && csResult.economics_whomake.completion && csResult.economics_howmakemoney.completion && csResult.economics_howdelivered.completion && csResult.economics_economicburden.completion && csResult.economics_currentsolutioncosts.completion && csResult.economics_consumercosts.completion && csResult.specificquestions.completion && csResult.references.completion && csResult.c_comparativeadvantages.completion && csResult.c_construction.completion && csResult.c_development.completion)
                      ) {
                        axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update_phase`, {
                          invention_id: component.$route.params.id,
                          phase: 'phase-4'
                        })
                          .then(function (response) {
                            console.info('Update Phase Results: ', response.data)

                            saveAllComplete('invention status has been updated to Invention Review')
                          })
                          .catch(function (errorResponse) {
                            tools.alert({
                              type: 'error',
                              message: `Changes to ${component.C.form.selected.invention.title} have been saved, but status failed to be updated to Invention Review.`,
                              errorResponse: errorResponse
                            })
                          })
                      } else {
                        saveAllComplete()
                      }
                    }

                    clearTimeout(component.C.timer.saveIndicator)

                    component.C.timer.saveIndicator = setTimeout(function () {
                      component.C.form.state.recentSaveActive = false
                    }, 5000)
                  })
                })
              }
            }
          },
          trigger: {
            scrollToTop: () => {
              document.body.scrollTop = document.documentElement.scrollTop = 0
            },
            exportDocument: () => {
              var component = this

              var $targetElement = $('#js-invention-document')

              var documentContent = '<!DOCTYPE html>' + $targetElement.get(0).outerHTML

              var documentBlob = htmlDocx.asBlob(documentContent, {
                orientation: 'portrait'
              })

              saveAs(documentBlob, `${component.C.form.selected.invention.title}.docx`)
            },
            setupInvention: (isInitialization) => {
              var component = this

              axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/detail`, {
                params: {
                  invention_id: component.$route.params.id
                }
              })
                   .then(response => {
                     var inventionDataItem = (response && response.data && response.data.data && response.data.data.invention) || {}
                     var isEditable = false

                     component.C.data.invention = inventionDataItem
                     component.C.state.isEditable = isEditable

                     component.C.form.selected.invention_id = inventionDataItem.id
                     component.C.form.selected.invention.title = inventionDataItem.title
                     component.C.form.selected.invention.description = inventionDataItem.description
                     component.C.form.selected.invention.search_list = inventionDataItem.search_list
                     component.C.form.selected.invention.keywords = inventionDataItem.keywords
                     component.C.form.selected.invention.search_results = inventionDataItem.search_results
                     component.C.form.selected.invention.action = inventionDataItem.action
                     component.C.form.selected.invention.action_note = inventionDataItem.action_note
                     component.C.form.selected.invention.search = inventionDataItem.searches // ### Incomplete
                     component.C.form.selected.invention.uploaded_filename = inventionDataItem.uploaded_filename

                     var targetOpportunityID = (inventionDataItem.opportunity && inventionDataItem.opportunity.id)
                     if (targetOpportunityID === -1) {
                       component.C.form.selected.invention.invention_opportunity_id = '$other'
                     } else {
                       component.C.form.selected.invention.invention_opportunity_id = targetOpportunityID
                     }

                     component.C.form.selected.invention.organization_id = (inventionDataItem.organization && inventionDataItem.organization.id)
                     component.C.form.selected.invention.bulk_read_access = inventionDataItem.bulk_read_access || null
                     component.C.form.selected.scratchpad = (inventionDataItem.scratchpad && inventionDataItem.scratchpad.content) || ''

                     component.C.form.selected.co_inventors = []

                     for (var i = 0; i < inventionDataItem.co_inventors.length; i++) {
                       component.C.form.selected.co_inventors.push({
                         $name: `${inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.firstname} ${inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.lastname}`,
                         user_id: inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.id,
                         access: inventionDataItem.co_inventors[i].access
                       })
                     }

                     component.C.form.selected.comments.$list = inventionDataItem.comments

                     var containerSectionItem = inventionDataItem.container_section || {}

                     function presetContainerSection (targetKey) {
                       containerSectionItem[targetKey] = containerSectionItem[targetKey] || {
                         content: ''
                       }
                     }

                     for (i = 0; i < component.C.config.containerSections.length; i++) {
                       presetContainerSection(component.C.config.containerSections[i])
                     }

                     containerSectionItem.c_comparativeadvantages = containerSectionItem.c_comparativeadvantages || {
                       components: []
                     }
                     containerSectionItem.c_construction = containerSectionItem.c_construction || {
                       components: []
                     }
                     containerSectionItem.c_development = containerSectionItem.c_development || {
                       components: []
                     }

                     component.C.state.container[2].items = []
                     for (i = 0; i < containerSectionItem.c_comparativeadvantages.components.length; i++) {
                       var componentItem = containerSectionItem.c_comparativeadvantages.components[i]

                       component.C.state.container[2].items.push({
                         key: componentItem.type,
                         title: componentItem.type, // ### TEMPORARY - Need label
                         href: `#comparativeadvantages-${i}`,
                         useByIndex: true
                       })
                     }
                     for (i = 0; i < component.C.state.container[2].$baseItems.length; i++) {
                       component.C.state.container[2].items.push(component.C.state.container[2].$baseItems[i])
                     }

                     component.C.state.container[3].items = []
                     for (i = 0; i < containerSectionItem.c_construction.components.length; i++) {
                       componentItem = containerSectionItem.c_construction.components[i]

                       component.C.state.container[3].items.push({
                         key: componentItem.type,
                         title: componentItem.type, // ### TEMPORARY - Need label
                         href: `#construction-${i}`,
                         useByIndex: true
                       })
                     }
                     for (i = 0; i < component.C.state.container[3].$baseItems.length; i++) {
                       component.C.state.container[3].items.push(component.C.state.container[3].$baseItems[i])
                     }

                     component.C.state.container[5].items = []
                     for (i = 0; i < containerSectionItem.c_development.components.length; i++) {
                       componentItem = containerSectionItem.c_development.components[i]

                       component.C.state.container[5].items.push({
                         key: componentItem.type,
                         title: componentItem.type, // ### TEMPORARY - Need label
                         href: `#development-${i}`,
                         useByIndex: true
                       })
                     }
                     for (i = 0; i < component.C.state.container[5].$baseItems.length; i++) {
                       component.C.state.container[5].items.push(component.C.state.container[5].$baseItems[i])
                     }

                     component.C.form.selected.invention.container_section = containerSectionItem

                     if (isInitialization) {
                       component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base'

                       if (containerSectionItem.c_construction.components.length === 0) {
                         component.C.state.tab.construction.active = 'construction-base'
                       } else {
                         component.C.state.tab.construction.active = 'construction-0'
                       }

                       if (containerSectionItem.c_development.components.length === 0) {
                         component.C.state.tab.development.active = 'development-base'
                       } else {
                         component.C.state.tab.development.active = 'development-0'
                       }

                       if (component.C.form.selected.invention.organization_id) {
                         axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/organizations/opportunities_and_inventors`, {
                           params: {
                             organization_id: component.C.form.selected.invention.organization_id
                           }
                         })
                              .then(response => {
                                var opportunitiesList = (response && response.data && response.data.data && response.data.data.invention_opportunities) || []
                                var peopleList = (response && response.data && response.data.data && response.data.data.inventors) || []

                                opportunitiesList.push({
                                  id: '$other',
                                  title: 'Other'
                                })

                                component.C.form.list.opportunities = opportunitiesList
                                component.C.form.list.inventors = peopleList

                                component.C.form.selected.$collaborator.$item = null
                                component.C.form.selected.$collaborator.access = null
                              })
                              .catch(errorResponse => {
                                tools.alert({
                                  type: 'error',
                                  errorResponse: errorResponse
                                })
                              })
                       }

                       setTimeout(function () {
                         component.C.state.initialized = true
                       }, 10000)
                     }
                   })
                   .catch(errorResponse => {
                     tools.alert({
                       type: 'error',
                       errorResponse: errorResponse
                     })
                   })
            },
            confirmComparativeadvantagesComponentDelete: _.noop,
            confirmConstructionComponentDelete: _.noop,
            confirmDevelopmentComponentDelete: _.noop
          },
          dictionary: {
            phase: {
              'phase-1': 'Concept',
              'phase-2': 'Invention Brief',
              'phase-3': 'Invention Full',
              'phase-4': 'Invention Review',
              'phase-5': 'Invention Complete'
            },
            bulk_read_access: {
              'only-inventors': 'Specific people',
              'anyone-organization': 'Anyone can comment'
            }
          }
        }
      }
    },
    created () {
      var component = this

      function initializeContainerSection (targetKey) {
        component.C.form.selected.invention.container_section[targetKey] = {
          content: ''
        }
        component.C.config.containerSections.push(targetKey)
      }

      for (var i = 0; i < component.C.state.container.length; i++) {
        var currentContainer = component.C.state.container[i]
        currentContainer.$baseItems = currentContainer.items || []

        for (var j = 0; j < currentContainer.items.length; j++) {
          if (currentContainer.items[j].includeAPI) {
            initializeContainerSection(currentContainer.items[j].key)
          }
          if (currentContainer.items[j].subAPIitems && currentContainer.items[j].subAPIitems.length > 0) {
            for (var k = 0; k < currentContainer.items[j].subAPIitems.length; k++) {
              initializeContainerSection(currentContainer.items[j].subAPIitems[k].key)
            }
          }
        }
      }

      component.C.trigger.setupInvention(true)
    },
    filters: {
      F_availableCollaborators: (currentList, selectedList) => {
        currentList = currentList || []
        var filteredList = []

        for (var i = 0; i < currentList.length; i++) {
          var currentCollaborator = currentList[i]

          var correspondingSelectedCollaborator = _.find(selectedList, function (selectedCollaborator) {
            return selectedCollaborator.user_id === currentCollaborator.id
          })

          if (!correspondingSelectedCollaborator) {
            filteredList.push(currentCollaborator)
          }
        }

        return filteredList
      },
      F_availableAccess: (currentList, targetPhase) => {
        var filteredList = []

        for (var i = 0; i < currentList.length; i++) {
          var currentCollaborator = currentList[i]

          if (currentCollaborator.value === 2) {
            if (targetPhase === 'phase-3' || targetPhase === 'phase-4' || targetPhase === 'phase-5') {
              filteredList.push(currentCollaborator)
            }
          } else {
            filteredList.push(currentCollaborator)
          }
        }

        return filteredList
      }
    }
  }
</script>
<style lang='scss', scoped>
  .presentation {
    position: relative;
    background-color: white;
    max-width: 1024px;
    margin: 2em auto 0;
    box-shadow: 0 0 0 9999px #8D9AA3 !important;
  }

  ol {
    list-style-position: outside;
    margin-left: 0;
    margin-right: 0;
    padding-left: 1em;
    &.presentation--list {
      list-style-position: inside;
      padding-left: 0;
      section {
        margin-bottom: 1em;
      }
    }
  }
  .milestone--list li {
    padding: 8px 0;
    margin-left: 18px;
  }
  .tabs__content {
    padding: 1em 0;
    transition: none;
  }
  article {
    font-size: 1.2em;
  }
  .invention__progress {
    width: 190px;
  }
  .editor__nav {
    .toolbar__title {
      font-weight: 600;
      letter-spacing: 0em;
    }
  }

.hide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Inventions/Presentation.vue